import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { BaseInterface } from '../../../models/quotation-model/catalogs/base.model';
import { Brand } from '../../../models/quotation-model/catalogs/brand.model';
import {
  QuoterBrandPaged,
  QuoterBrand,
} from '../../../models/quotation-model/catalogs/quoterConfig/quoter-brand.model';
import {
  QuoterModelPaged,
  QuoterModel,
} from '../../../models/quotation-model/catalogs/quoterConfig/quoter-model.model';
import {
  QuoterYearPaged,
  QuoterYear,
} from '../../../models/quotation-model/catalogs/quoterConfig/quoter-year.model';
import { CommonFilterRequest, CommonResult } from '../../../models/quotation-model/customer.model';

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getByDestinationId(destinationId: number): Observable<Brand[]> {
    return this.http.get<Brand[]>(this.URL_API + '/brand?destinationId=' + destinationId);
  }

  getCurrencies(): Observable<BaseInterface[]> {
    return this.http.get<BaseInterface[]>(this.URL_API + '/Brand/GetQuoterCurrencies');
  }

  getBrandsToCoverageVehicleUse(coverageId: number, useId: number): Observable<Brand[]> {
    return this.http.get<Brand[]>(
      this.URL_API +
        '/Brand/GetBrandsToCoverageVehicleUse?coverageId=' +
        coverageId +
        '&useId=' +
        useId,
    );
  }

  getBrandsToDealer(dealerProgramId: number): Observable<Brand[]> {
    return this.http.get<Brand[]>(
      this.URL_API + '/Brand/GetBrandsToDealer?dealerProgramId=' + dealerProgramId,
    );
  }

  getPagedBrands(filters: CommonFilterRequest): Observable<QuoterBrandPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '');
    return this.http.get<QuoterBrandPaged>(this.URL_API + '/Brand/GetPagedBrands', { params });
  }

  upsertQuoterBrand(upsertBrand: QuoterBrand) {
    return this.http.post<CommonResult>(this.URL_API + '/Brand/UpsertBrand', upsertBrand);
  }

  getPagedBrandModels(filters: CommonFilterRequest, brandId: number): Observable<QuoterModelPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '')
      .set('brandId', brandId);
    return this.http.get<QuoterModelPaged>(this.URL_API + '/Brand/GetPagedBrandModels', { params });
  }

  upsertQuoterBrandModel(upsertModel: QuoterModel) {
    return this.http.post<CommonResult>(this.URL_API + '/Brand/UpsertBrandModel', upsertModel);
  }

  getPagedBrandModelYears(
    filters: CommonFilterRequest,
    modelId: number,
  ): Observable<QuoterYearPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '')
      .set('modelId', modelId);
    return this.http.get<QuoterYearPaged>(this.URL_API + '/Brand/GetPagedBrandModelYears', {
      params,
    });
  }

  upsertQuoterBrandModelYear(upsertYear: QuoterYear) {
    return this.http.post<CommonResult>(this.URL_API + '/Brand/UpsertBrandModelYear', upsertYear);
  }
}
